import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { from, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import selectStyles from '../../../util/selectStyles';
import WhatsappFlowModelMC from '../../../presentation/models/WhatsappFlowModelMC';
import AdvancedActions from './AdvancedActions';
import InactivityTimeoutConfig from './InactivityTimeoutConfig';

const WhatsappFlowOption = ({
  chatbot,
  chatbotOption,
  setChatbotOption,
  errors,
  setErrors,
  customerColumns
}) => {
  const [flowOptions, setFlowOptions] = useState([]);

  useEffect(() => {
    loadFlows();
  }, []);

  const loadFlows = () => {
    from(WhatsappFlowModelMC.get({ status: 'PUBLISHED' })).pipe(
      catchError(() => of({ whatsapp_flows: [] }))
    ).subscribe((res) => {
      const options = (res.whatsapp_flows || []).map((flow) => ({
        value: flow.id,
        label: flow.default_header_text
      }));
      setFlowOptions(options);
    });
  };

  const handleSelectFlow = (option) => {
    setErrors((prev) => ({ ...prev, whatsapp_flow_id: '' }));
    setChatbotOption((prev) => ({
      ...prev,
      whatsapp_flow_id: option ? option.value : null
    }));
  };

  return (
    <div className="container-fluid-no-padding">
      <div className="row col-md-12 px-0">
        <div className="col-md-12 mt-10 px-0">
          <div className="figma-field mb-0">
            <label className="col-form-label fz-14 fw-bold">WhatsApp Flow</label>
            {errors.whatsapp_flow_id && (
              <span className="ml-10 error-msg fz-12">{errors.whatsapp_flow_id}</span>
            )}
            <Select
              options={flowOptions}
              placeholder="Selecciona un WhatsApp Flow"
              className="select-tag"
              classNamePrefix="select-tag"
              styles={selectStyles}
              onChange={handleSelectFlow}
              value={flowOptions.find((el) => el.value === chatbotOption.whatsapp_flow_id) || null}
              name="whatsapp_flow_id"
              components={{
                IndicatorSeparator: () => null
              }}
            />
          </div>
        </div>
      </div>

      <div className="divider my-20" />

      <AdvancedActions
        chatbot={chatbot}
        chatbotOption={chatbotOption}
        setChatbotOption={setChatbotOption}
        customerColumns={customerColumns}
        errors={errors}
      />

      <div className="divider my-20" />

      <InactivityTimeoutConfig
        chatbotOption={chatbotOption}
        setChatbotOption={setChatbotOption}
        errors={errors}
        setErrors={setErrors}
      />
    </div>
  );
};

export default WhatsappFlowOption;
